export const MARKETING_JSON_URL = "/marketing.json";
